import { Tabs } from 'antd'
import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import moment from 'moment'
import React, { useState } from 'react'
import BatchFilter from './Partials/CandidateRating/index'
import DateFilter from './Partials/Date/index'
import DegreeAndDepartmentFilter from './Partials/DegreeAndDepartment/index'
import SpecialisationFilter from './Partials/Specialisation/index'
import { MenuFlex, StyledTab, SubmitFlex } from './style'

const { TabPane } = Tabs

const IndividualDriveFilter = ({
  setSearchValue,
  candidateRating,
  setCandidateRating,
  setInterviewRound,
  interviewRound,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  getCandidateList,
  rolesMetrics,
  degreeList,
  specialisationList,
  specialisationValue,
  setSpecialisationValue,
  keySpecialisation,
  setKeySpecialisation,
  setFilterData,
  setSearchParams,
  collegeList,
  college,
  setCollege,
  setCollegeSearch,
  setStatus,
  currentCount,
  totalCount,
  filterStatus,
  setFilterStatus,
  currentTab,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  let filteredData = {}
  const [batchFilter, setBatchFilter] = useState([])
  const [dateFilter, setDateFilter] = useState([])
  const arrayIntoString = data => {
    let dataString = data ? data?.join(',') : data
    return dataString
  }

  const onCancelFilter = () => {
    setCandidateRating(filteredData?.rating)
    setCheckedIds(filteredData?.degree)
    setIsMenuOpen(!isMenuOpen)
    setCheckedKeys(filteredData?.degreeKeys)
    setInterviewRound(filteredData?.round || 'all_candidates')
    setSearchParams({
      stage: filteredData?.round || 'all_candidates',
    })
    setStatus(filteredData?.status)
    setFilterStatus(filteredData?.status)
    setCollege(filteredData?.collogeName)
  }

  const onApplyFilter = () => {
    let specialisation = arrayIntoString(specialisationValue)

    setFilterData({
      specialisation: specialisation,
      degree: checkedIds,
      startBatch: batchFilter?.startBatch
        ? moment(batchFilter?.startBatch, 'YYYY').unix()
        : null,
      endBatch: batchFilter?.endBatch
        ? moment(batchFilter?.endBatch, 'YYYY').unix()
        : null,
      startDate: dateFilter?.startDate
        ? moment(dateFilter?.startDate).toISOString()
        : null,
      endDate: dateFilter?.endDate
        ? moment(dateFilter?.endDate).toISOString()
        : null,
    })

    setSearchParams({
      stage: interviewRound || 'all_candidates',
    })
    setStatus(filterStatus)
    setIsMenuOpen(!isMenuOpen)
  }

  const menu = (
    <MenuFlex column className="filter">
      <StyledTab tabPosition={'left'}>
        <TabPane tab="Batch" key="1">
          <BatchFilter setBatchFilter={setBatchFilter} />
        </TabPane>

        <TabPane tab="Degree&Department" key="2">
          <DegreeAndDepartmentFilter
            checkedKeys={checkedKeys}
            setCheckedKeys={setCheckedKeys}
            checkedIds={checkedIds}
            setCheckedIds={setCheckedIds}
            degreeList={degreeList}
          />
        </TabPane>

        <TabPane tab="Specialization" key="3">
          <SpecialisationFilter
            cityList={specialisationList || []}
            cityValue={specialisationValue}
            setCityValue={setSpecialisationValue}
            keyCity={keySpecialisation}
            setKeyCity={setKeySpecialisation}
          />
        </TabPane>
        <TabPane tab="Date" key="4">
          <DateFilter setDateFilter={setDateFilter} />
        </TabPane>
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={onCancelFilter} />
        <Button.Primary text="Apply Filter" onClick={onApplyFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      setSearchValue={setSearchValue}
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
      currentCount={currentCount}
      totalCount={totalCount}
    />
  )
}

export default IndividualDriveFilter
